import React from "react";
import MpWithSidebarLayout from "../../components/MpWithSidebarLayout/MpWithSidebarLayout";

import MemberActivityList from "pages/Survey/MemberActivityList";
import RewardsPage from "pages/RewardsPage/RewardsPage";
import PassPage from "pages/PassPage/PassPage";
import VisitIntake from "pages/Appointment/components/VisitIntake";
import SurveyMemberPortal from "pages/Survey/SurevyMemberPortal";
import MemberPortalAgreement from "pages/MemberPortalAgreement/MemberPortalAgreement";
import Dashboard from "pages/Dashboard/Dashboard";
import ResourcesPage from "pages/ResourcesPage/ResourcesPage";
import ProfilePage from "pages/ProfilePage/ProfilePage";
import ProviderSearchPage from "pages/ProviderSearchPage/ProviderSearchPage";
import PregnancyWeightCalculator from "pages/PregnancyWeightCalculator/PregnancyWeightCalculator";
import Language from "pages/Language/Language";
import MemberPortalThankYou from "pages/MemberPortalThankYou/MemberPortalThankYou";
const MemberPageRoutes = {
  path: "member",
  element: <MpWithSidebarLayout />,
  children: [
    { path: "", element: <MemberActivityList /> },
    { path: "activities", element: <MemberActivityList /> },
    { path: "rewardspage", element: <RewardsPage /> },
    { path: "pass", element: <PassPage /> },
    { path: "visitintake", element: <VisitIntake /> },
    { path: "memberportalagreement", element: <MemberPortalAgreement /> },
    {
      path: "memberportalthankyou",
      element: <MemberPortalThankYou />,
      // errorElement: <ErrorPage />,
    },
    { path: "dashboard", element: <Dashboard /> },
    { path: "surveymemberportal", element: <SurveyMemberPortal /> },
    { path: "resources", element: <ResourcesPage /> },
    { path: "profilepage", element: <ProfilePage /> },
    { path: "providerSearchPage", element: <ProviderSearchPage /> },
    {
      path: "preganancyweightcalculator",
      element: <PregnancyWeightCalculator />,
    },
    { path: "languageselection", element: <Language /> },
  ],
};

export default MemberPageRoutes;
